import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";
import { Trophy } from "lucide-react";

export default function SportsTable() {
  const { selected } = useProvince();
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    api.get(`/sports${selected ? `?province_id=${selected.id}` : ""}`).then((r) => setTeams(r.data || [])).catch(() => {});
  }, [selected?.id]);
  if (!teams.length) return null;
  return (
    <div className="w-full bg-white rounded-lg border border-gray-100 p-5">
      <div className="flex items-center gap-2 mb-3">
        <Trophy className="w-5 h-5 text-[#e11d2a]" />
        <h3 className="text-lg font-black">PUAN DURUMU & FİKSTÜR</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase text-gray-500 border-b">
              <th className="py-2">#</th>
              <th className="py-2">Takım</th>
              <th className="py-2 text-center">O</th>
              <th className="py-2 text-center">G</th>
              <th className="py-2 text-center">B</th>
              <th className="py-2 text-center">M</th>
              <th className="py-2 text-center">P</th>
            </tr>
          </thead>
          <tbody>
            {teams.map((t) => (
              <tr key={t.id} className="border-b last:border-0">
                <td className="py-2 font-semibold">{t.standing_position}</td>
                <td className="py-2 flex items-center gap-2">
                  {t.logo && <img src={t.logo} alt="" className="w-6 h-6 rounded-full" />}
                  <span>{t.team_name}</span>
                </td>
                <td className="py-2 text-center">{t.played}</td>
                <td className="py-2 text-center text-emerald-600 font-semibold">{t.won}</td>
                <td className="py-2 text-center text-amber-600 font-semibold">{t.drawn}</td>
                <td className="py-2 text-center text-red-600 font-semibold">{t.lost}</td>
                <td className="py-2 text-center font-bold">{t.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
